"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-core/lib/constant.js
// module id = 536
// module chunks = 0